import React from 'react';
import { DatePicker } from 'formik-mui-lab';
import FormControl from '@mui/material/FormControl';

const FormikDatePicker = (props) => {
    const { fullWidth } = props

    return (
        <FormControl fullWidth={fullWidth}>
            <DatePicker
                {...props}
            />
        </FormControl>
    );
};

export default FormikDatePicker;
